<template>
  <div class="product"
    :style="{'filter': `drop-shadow(0 0 0.4rem #${this.getDropShadow(this.division?.product?.color, product?.color)})`}"
    @mouseenter="mouseEnterMethod" @mouseleave="mouseLeaveMethod"
    @click="handleSelectProduct(product)">
    <img 
    :style="{'filter': `drop-shadow(0 0 0.4rem #${this.getDropShadow(this.division?.product?.color, product?.color)})`}"
    :src="product.icon" />
    <p 
    :style="{'filter': `drop-shadow(0 0 0.4rem #${this.getDropShadow(this.division?.product?.color, product?.color)})`}"
    class="product-name">{{product.name}}</p>
  </div>

</template>

<script>export default {
  name: 'individual-product',
  props: {
    product: Object,
    division: Object
  },
  data() {
    return {
      hover: false
    }
  },
  methods: {
    handleSelectProduct(product) {
      this.$emit('productSelected', product)
    },
    mouseEnterMethod() {
      this.hover = true;
    },
    mouseLeaveMethod() {
      this.hover = false
    }
  },
  computed: {
    getDropShadow() {
      return (divisionColor, productColor) => {
        if (this.hover) {
          return productColor
        } else {
          if (this.division?.product) {
            // There's a product already selected for this division
            if (divisionColor === productColor) {
              return productColor
            }
          }
        }
        return 'FFF'
      }
    }
  }
}
</script>

<style scoped>
.product-name {
  margin: 0 !important;
  /* font-family: 'Inter', sans-serif; */
  font-family: 'Roboto', sans-serif;
  text-transform: capitalize;
}

.product {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.product:hover {
  transform: scale(1.1);
}

@media screen and (max-width: 700px) {
  .product-name {
    font-size: 0.7rem;
  }


}
</style>